import { ItemListStoryblok } from '../types/generated-storyblok';
import { ArticleArtist } from './Journals/ArticleArtist';
import { ArticleInsight } from './Journals/ArticleInsight';
import { ArticleLocation } from './Journals/ArticleLocation';
import { ArticleProduct } from './Journals/ArticleProduct';

interface ContentBlockItemListProps {
  blok: ItemListStoryblok;
}

export const ContentBlockItemList = ({ blok }: ContentBlockItemListProps) => (
  <div className="mx-auto flex w-full max-w-md flex-col gap-3 divide-y divide-divider/20 rounded-sm border border-divider/20 bg-white p-3 md:gap-4 md:p-4">
    {blok.items.map((item) => {
      switch (item.component) {
        case 'artistId':
          return <ArticleArtist key={item._uid} blok={item} variant="list" />;
        case 'locationItem':
          return <ArticleLocation key={item._uid} blok={item} />;
        case 'productId':
          return <ArticleProduct key={item._uid} blok={item} />;
        case 'insightId':
          return <ArticleInsight key={item._uid} blok={item} variant="list" />;
        default:
          return null;
      }
    })}
  </div>
);
